import React from 'react';
import ResetPassword from '../components/auth/ResetPassword';

export default function ResetPasswordPage() {
  return <ResetPassword />;
}

